module.exports = __webpack_public_path__ + "02bf4507e91c41b71162e9060e92c616.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-account-status/sp-account-status.html
// module id = 1064
// module chunks = 0